import { createSelector } from '@ngrx/store';
import { AppState } from '../../app.state';
import { FieldVisibilityState } from './field-visibility.reducer';
import { FieldVisibilityModule } from './field-visibility.types';

export const selectFieldVisibilityState = (state: AppState): FieldVisibilityState =>
  state.fieldVisibility;

export const selectHiddenFields = createSelector(
  selectFieldVisibilityState,
  (state) => state.hiddenFields
);

export const selectFieldVisibilityCatalog = createSelector(
  selectFieldVisibilityState,
  (state) => state.catalog
);

export const selectFieldVisibilityCatalogLoaded = createSelector(
  selectFieldVisibilityState,
  (state) => state.catalogLoaded
);

/**
 * True when the given field is visible for the current user/role.
 *
 * The frontend hides UI slots based on this selector; the backend independently
 * strips hidden keys from API responses (security boundary). If the field is
 * not in the role's hidden set, it is visible.
 */
export const selectIsFieldVisible = (
  moduleName: FieldVisibilityModule,
  fieldKey: string
) =>
  createSelector(selectHiddenFields, (hidden) => {
    const moduleHidden = hidden[moduleName] ?? [];
    return !moduleHidden.includes(fieldKey);
  });

export const selectHiddenFieldsForModule = (moduleName: FieldVisibilityModule) =>
  createSelector(
    selectHiddenFields,
    (hidden) => hidden[moduleName] ?? []
  );
